(() => {
  const revealSelector = [
    '.section-heading',
    '.two-column',
    '.pillar-grid > article',
    '.application-grid > article',
    '.regulatory-panel__inner',
    '.evidence-band__inner',
    '.page-kpis',
    '.split-proof',
    '.media-feature',
    '.timeline > article',
    '.evidence-list > article',
    '.regulatory-matrix > article',
    '.document-request',
    '.page-media-strip',
    '.resource-grid > article',
    '.scope-grid > article',
    '.sample-panel',
    '.form-panel',
    '.product-lite__media',
    '.product-lite__info',
    '.final-cta .section-inner'
  ].join(',');

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const markVisible = (items) => {
    items.forEach((item) => {
      item.classList.add('is-visible');
      item.style.removeProperty('--akk-reveal-delay');
    });
  };

  const prepareItems = (root = document) => {
    return Array.from(root.querySelectorAll(revealSelector))
      .filter((item) => !item.closest('.home-hero'))
      .map((item, index) => {
        item.classList.add('akk-reveal');
        item.style.setProperty('--akk-reveal-delay', `${Math.min((index % 4) * 70, 210)}ms`);
        return item;
      });
  };

  const initReveal = (root = document) => {
    const items = prepareItems(root);
    if (!items.length) return;

    document.documentElement.classList.add('akk-motion-ready');

    if (reduceMotion() || !('IntersectionObserver' in window)) {
      markVisible(items);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.style.removeProperty('--akk-reveal-delay');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.14
    });

    items.forEach((item) => observer.observe(item));
  };

  const initHero = () => {
    const heroItems = document.querySelectorAll('.home-hero__copy, .hero-credential');
    heroItems.forEach((item) => item.classList.add('is-visible'));
  };

  const init = (root = document) => {
    initHero();
    initReveal(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
